module.exports = __webpack_public_path__ + "img/stock0.8d10427e.png";